import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { lessonActions } from '../actions/lesson.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class LessonEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getLessons$ = createEffect(() => {
        return this.actions.pipe(
            ofType(lessonActions.getLesson),
            mergeMap(({ id }) => {
                return this.httpService.getLesson(id).pipe(
                    // finalizeLoader('library-get-lesson'), // FIXME: Silent loader required, that does not show up in the UI
                    map((lesson) => lessonActions.getLessonSuccess({ lesson })),
                    catchError(() => of(lessonActions.getLessonError({ id }))),
                );
            }),
        );
    });
}
